/// <amd-module name="TFS/ThemeManagement/ThemePanelService" />
import * as React from "react";

import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssLayoutManager } from "VSS/Platform/Layout";
import { ThemePanel } from "./Components/ThemePanel/ThemePanel";
import { ITfsThemeService } from "./TfsThemeService";

// There can only be a single feature panel at any given time.
let panelOpen: boolean;

/**
 * Service for displaying the theme management panel
 */
export interface IThemePanelService extends IVssService {
    /**
     * Show the theme management panel
     */
    show: () => void;
}

class ThemePanelService extends VssService implements IThemePanelService {
    public show(): void {
        // If the panel were previously opened we will ignore the request to show it again.
        if (panelOpen) {
            return;
        }

        const layoutService = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        layoutService.renderCallout((onDismiss: () => void) => {
            // Have a local function for closing the panel cleaning up our state.
            const onPanelDismiss = (): void => {
                panelOpen = false;
                onDismiss();
            };

            // Render the feature panel with the initial props.
            const themeService = this.pageContext.getService<ITfsThemeService>("ITfsThemeService");
            return React.createElement(
                ThemePanel,
                {
                    onDismiss: onPanelDismiss,
                    themeService
                },
                null
            );
        });

        panelOpen = true;
    }
}

Services.add("IThemePanelService", { serviceFactory: ThemePanelService });
